import firebase from "./../firebase/firebase";

export enum ANALYTICS_EVENTS {
  // Auth / User
  SIGN_IN = "sign_in",
  SIGN_UP = "sign_up",
  SIGN_OUT = "sign_out",
  CREATE_MATTERMOST_USER = "create_mattermost_user",
  DELETE_USER = "delete_user",
  FORGOT_PASSWORD = "forgot_password",

  // Stand
  STAND_VISIT = "stand_visit",

  // Event
  EVENT_VISIT = "event_visit",

  // Profile
  UPDATE_PROFILE_IMG = "update_profile_img",
  UPDATE_PERSONAL_DATA = "update_personal_data",
  UPDATE_BUSINESS_DATA = "update_business_data",

  // Chat
  GENERAL_CHAT = "general_chat",
  STAND_CHAT = "stand_chat",
  USER_CHAT = "start_chat_with_user",

  // Appointments
  REQUEST_APPOINTMENT = "appointment_request",
  RESPONSE_APPOINTMENT_KO = "appointment_decline",
  RESPONSE_APPOINTMENT_OK = "appointment_accept",

  // Other
  BUSINESS_CARD = "leave_business_card",
  ADD_TO_CONTACTS = "add_to_contacts",
  DOWNLOAD_PRODUCT = "download_product",
  DOWNLOAD_BROCHURE = "download_brochure"
}

/**
 * Track event on google analytics
 * @function
 *
 * @param eventName
 * @param eventParams
 */
export const trackAnalyticsEvent = (eventName: string, eventParams?: any) => {
  if (process.env.REACT_APP_ENV === "development") {
    return;
  }

  firebase.analytics().logEvent(eventName, eventParams);
};
